import React from "react";
// import LogNav from "../layout/LoggedNav";
// import MemberCard from '../Billing/MemberCard'
// import CancelAccount from '../Billing/CancelAccount'
import MemberCardBenifits from "./MemberCardBenifits";
import RenewMember from "./RenewMember";
const MemberDetailBenifits = () => {

    return (
        <>

                <div className="member__detail">
                    <MemberCardBenifits/>
                    <RenewMember/>


                </div>






        </>
    );
};
export default MemberDetailBenifits;
